import React, { Component } from 'react'
import ContMessageI18N from '../../containers/ContMessageI18N';
import NumberFormatCustom from '../std/NumberFormatCustom';

const keyList = ['ICE', 'electric', 'combined'];
const unitList = ['KW', 'HP', 'BHP'];

class TestVehicleMaximumPower extends Component {

	constructor(props) {
		super(props);
		this.state = TestVehicleMaximumPower.getStateFromProps(props);
		this.onChange = props.onChange;
	}
	static getStateFromProps(props) {
		let retainedKey = props.data.key;
		if (!retainedKey) {
			retainedKey = keyList[0];
		}
		let retainedUnit = props.data.unit;
		if (!retainedUnit) {
			retainedUnit = unitList[0];
		}
		return {
			value: props.data.value,
			key: retainedKey,
			unit: retainedUnit
		};
	}
	static getDerivedStateFromProps(props, currentState) {
		if (currentState !== TestVehicleMaximumPower.getStateFromProps(props)) {
			return TestVehicleMaximumPower.getStateFromProps(props);
		}
		return null;
	}

	onChange = function (data) { }

	handleChangeGeneric = name => event => { this.handleChange({ [name]: event.target.value }, name); };
	handleChange(data, name) {
		var updateVar = { ...this.state };
		updateVar[name] = data[name];
		if (updateVar.value != null) {
			updateVar.value = updateVar.value * 1.0;
		}
		this.onChange(updateVar);
	}
	getLabel(fieldname, i18nKey) { return this.props.settings.isDevelopperView ? fieldname	
								: this.getMessage(i18nKey); }
	getItemLabel(value, fieldname) {	
		return ( this.getMessage(`vehicle.features.maximumPowers.${fieldname}.${value}`, value))
	}
	getMessage(i18nKey, optionValue) {
		let prefix = null;
		if (optionValue) {
			prefix = `${optionValue} - `;
		}
		return <ContMessageI18N i18n={i18nKey} optionValue={optionValue} prefix={prefix} />
	}

	render() {
		return (
			<React.Fragment>
				<div className="col-auto">
					<label htmlFor={`maximumPowers-value-${this.state.key}-${this.state.unit}`} className="form-label">
						{this.getLabel('value', 'generics.value')}
					</label>
					<NumberFormatCustom id={`maximumPowers-value-${this.state.key}-${this.state.unit}`} className="form-control"
						value={this.state.value} onChange={this.handleChangeGeneric('value')} />
				</div>
				<div className="col-auto form-floating">
					<select className="form-select" id={`maximumPowers-unit-${this.state.key}-${this.state.unit}`}
						onChange={this.handleChangeGeneric('unit')} value={this.state.unit}>
						{unitList.map((code, index) => (
							<React.Fragment key={index}>{this.getItemLabel(code, 'unit')}</React.Fragment>
						))}
					</select>
					<label htmlFor={`maximumPowers-unit-${this.state.key}-${this.state.unit}`} >
						{this.getLabel('unit', 'vehicle.features.maximumPowers.unit')}
					</label>
				</div>
				<div className="col-auto form-floating">
					<select className="form-select" id={`maximumPowers-key-${this.state.key}-${this.state.unit}`}
						onChange={this.handleChangeGeneric('key')} value={this.state.key}>
						{keyList.map((code, index) => (
							<React.Fragment key={index}>{this.getItemLabel(code, 'key')}</React.Fragment>
						))}
					</select>
					<label htmlFor={`maximumPowers-key-${this.state.key}-${this.state.unit}`} >
						{this.getLabel('key', 'vehicle.features.maximumPowers.key')}
					</label>
				</div>
			</React.Fragment>
		)
	}
}

export default (TestVehicleMaximumPower)
